import { useMutation } from '@apollo/client'
import { updateRelationship as updateRelationshipGql }
   from 'src/core/graphql/mutations/updateRelationship.gql'

const useUpdateRelationship = (mutationHookOptions) => {
   const [updateRelationship, { called, client, data, error, loading }] =
      useMutation(updateRelationshipGql, mutationHookOptions)

   const wrappedMutationFn = (filter, input, mutationFnOptions) => updateRelationship({
      variables: { ...filter, input },
      ...mutationFnOptions
   })

   return {
      updateRelationship: wrappedMutationFn,
      called,
      client,
      error,
      mutating: loading,
      result: data
   }
}

export default useUpdateRelationship
